import React from "react";
import PropTypes from "prop-types";

export default function NotificationItemDetails({ message, orgType, orgName, buttonConfigs = [] }) {
  return (
    <span className="notification-item__details">
      <div className="notification-dropdown__item-message" data-attribute="item-message">{message}</div>
      <span>
        {buttonConfigs.map((button, key) =>
          <a
            href={button.url} className="notification-dropdown__item-button" data-attribute="item-button"
            key={key} target="_blank" rel= "noopener noreferrer">
            {button.label}
          </a>
        )}
      </span>
      <div className="notification-item__org">
        <span className="notification-item__org-type" data-attribute="org-type">{orgType} </span>
        <span className="notification-item__org-name" data-attribute="org-name">{orgName}</span>
      </div>
    </span>
  );
}

NotificationItemDetails.propTypes = {
  orgType: PropTypes.string.isRequired,
  orgName: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  buttonConfigs: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.string))
};
